import React, { Component } from "react";
import TopBar from "../menus/TopBar";
import ContactBar from "../menus/ContactBar";

class About extends Component {
  render() {
    return (
      <div className="flex-contain-page">
        <div className="light-border">
          <div className="red-background">
            <div className="about-contact-max-width">
              <TopBar variant="red" />
              <div className="main-content">
                <div>
                  <h3>About</h3>
                  <h4>
                    Jade Law explores synesthetic experiences, visualising music
                    and emotion in abstract form.
                  </h4>
                  <br />
                  <p className="p2">
                    Through her practice, she investigates the intersection of
                    sound and vision, creating abstract works that capture the
                    emotions embedded in music. Each piece is a synesthetic
                    moment translated into form and colour, inviting viewers to
                    experience the rhythm, tone, and energy of the original
                    composition.
                  </p>
                  <p className="p2">
                    Jade holds an MA in Graphic Media Design from the University
                    of the Arts London, where she developed a foundation in
                    visual experimentation and conceptual design. Her practice
                    continues to be shaped by a fascination with how art can
                    communicate emotion and synesthetic perception through
                    abstraction.
                  </p>
                </div>
                <div>
                  <h4>Artist Statement</h4>
                  <br />
                  <p className="p2">
                    Jade's practice is concerned with the conditions under which
                    memory is encountered. It examines memory not as a stable
                    narrative of the past, but as a temporal disturbance,
                    something that returns as sensation, pressure, or residue
                    within the body. In this sense, the past is not positioned
                    behind the present, but intermittently inhabits it,
                    interrupting linear time through fragments that resist
                    coherence.
                  </p>
                  <p className="p2">
                    The work investigates the difference between sound and image
                    as temporal experiences. Sound unfolds and dissipates,
                    leaving traces that cannot be fully retained, while images
                    suspend time, allowing moments to be revisited and held.
                    Working with isolated moments of sound, interruption, and
                    recurrence, she treats deconstruction as a form of sustained
                    attention. The work does not aim to resolve meaning or
                    reconstruct narrative. Instead, it remains with sensation as
                    it emerges, fragments, and fades.
                  </p>
                  <p className="p2">
                    Forms resist symmetry, closure, and hierarchy. They appear
                    partial and unstable, composed through accumulation,
                    erosion, and drift, reflecting inner landscapes shaped by
                    embodied memory.
                  </p>
                  <p className="p2">
                    The resulting works function as sites of slowed perception.
                    Within these spaces, viewers are invited into an intimate
                    encounter with their own temporal and emotional
                    associations. What remains unresolved persists, quietly and
                    insistently, in the present.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ContactBar />
      </div>
    );
  }
}

export default About;
